module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.definitionModule) ? _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('page-title', {
    attrs: {
      "image": _vm.moduleLogo,
      "title": _vm.$t('configurations.label')
    }
  }, [_c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': !_vm.definitionModule.module.status
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false)
      }
    }
  }, [_vm._v("\n        Inativo\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': _vm.definitionModule.module.status
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(true)
      }
    }
  }, [_vm._v("\n        Ativo\n      ")])])]), _vm._v(" "), (_vm.refreshAlert()) ? _c('div', [_c('h5', [_vm._v("Permissão Pendente")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "id": "configuration"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [(_vm.useAuthentication) ? _c('panel', {
    attrs: {
      "title": "Autenticação"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.authenticating,
      "label": "Autenticando..."
    }
  }), _vm._v(" "), (!_vm.authenticating) ? _c('span', {
    class: _vm.authenticated ? 'badge badge--success' : 'badge badge--danger',
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.authenticated ? 'Autenticado' : 'Não Autenticado'))]) : _vm._e(), _vm._v(" "), _vm._t("auth")], 2) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), ((_vm.useAuthentication && _vm.data) || _vm.saveButton) ? _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving,
      "type": "submit"
    }
  }, [_vm._v("Salvar")])]) : _vm._e()], 2)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Por favor, entre em "), _c('a', {
    attrs: {
      "href": "https://seller.magalu.com/"
    }
  }, [_vm._v("Painel Seller Integracommerce")]), _vm._v(" e realize a permissão de acesso ao Placemarket para renovação de token. Para dúvidas, entre em contato com o Suporte Placemarket")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b0157a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Shared.vue
// module id = 2953
// module chunks = 0